import { createSelector } from "reselect";

import {
  getAllContentModules,
  getAllContents,
  getSectionContentIds
} from "./state";
import * as contentsSelectors from "./state/contents";
import * as contentSelectors from "./state/contents/content";
import * as modulesSelectors from "./state/modules";

export default function makeGetSectionAnchorConceptModuleIds(
  sectionId: string
) {
  return createSelector(
    getAllContents,
    getAllContentModules,
    (state: any) => getSectionContentIds(state, sectionId),
    (allContents, allModules, sectionContentIds) =>
      contentsSelectors
        .listExistingContents(allContents, sectionContentIds)
        .map((content: any) =>
          contentSelectors.getContentModuleIds(content).first()
        )
        .filter(
          moduleId =>
            modulesSelectors.getContentModuleType(allModules, moduleId!) ===
            "concept"
        )
  );
}
